import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { Loader2 } from "lucide-react";

export default function AppleCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser, setToken } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = () => {
      const token = searchParams.get("token");
      const userParam = searchParams.get("user");
      const errorParam = searchParams.get("error");

      if (errorParam) {
        setError("Error al iniciar sesión con Apple");
        setTimeout(() => navigate("/login"), 3000);
        return;
      }

      if (token && userParam) {
        try {
          const userData = JSON.parse(userParam);
          localStorage.setItem("plazafy_token", token);
          localStorage.setItem("plazafy_user", JSON.stringify(userData));
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          setToken(token);
          setUser(userData);
          navigate("/dashboard");
        } catch (err) {
          console.error("Error parsing user data:", err);
          setError("Error al procesar datos del usuario");
          setTimeout(() => navigate("/login"), 3000);
        }
        return;
      }

      if (token) {
        // Token without user data - store and redirect
        localStorage.setItem("plazafy_token", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        setToken(token);
        navigate("/dashboard");
        return;
      }

      setError("No se recibió respuesta de Apple");
      setTimeout(() => navigate("/login"), 3000);
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      {error ? (
        <div className="text-center">
          <p className="text-red-400 mb-2">{error}</p>
          <p className="text-gray-500 text-sm">Redirigiendo al login...</p>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 animate-spin text-violet-500" />
          <p className="text-gray-400">Iniciando sesión con Apple...</p>
        </div>
      )}
    </div>
  );
}
